// Ders bazlı özet kartları toplayıcısı
import { SummaryCard } from '../../types';
import { allSummaryCards } from './subjects';

// Ana özet kartları dizisi - tüm ders modüllerini birleştirir
export const sampleSummaryCards: SummaryCard[] = allSummaryCards;